import { render, staticRenderFns } from "./round-btn.vue?vue&type=template&id=6b8fc41d&scoped=true&"
import script from "./round-btn.vue?vue&type=script&lang=ts&"
export * from "./round-btn.vue?vue&type=script&lang=ts&"
import style0 from "./round-btn.vue?vue&type=style&index=0&id=6b8fc41d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8fc41d",
  null
  
)

export default component.exports